<div class="d-flex align-items-center">
  <atx-avatar
    [image]="user?.profilePictureUrl"
    [fullName]="user?.displayName"
    [editable]="false"
    class="mr-2 flex-shrink-0 pointer-events-auto"
    size="s"
  ></atx-avatar>
  <div class="d-inline-flex flex-column">
    <span class="font-weight-medium">{{ user?.displayName }}</span>
    @if (date) {
    <span class="date text-muted">
      {{ date | date: dateFormat }}
    </span>
    }
  </div>
</div>
